import { render, staticRenderFns } from "./BdArticleList.vue?vue&type=template&id=771b516b&scoped=true&"
import script from "./BdArticleList.vue?vue&type=script&lang=js&"
export * from "./BdArticleList.vue?vue&type=script&lang=js&"
import style0 from "./BdArticleList.vue?vue&type=style&index=0&id=771b516b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771b516b",
  null
  
)

export default component.exports